import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType, CarouselActionType } from '../constants';

export class CarouselButtonApplicationEvent implements ApplicationEvent {
  type = ApplicationEventType.CarouselButton;

  constructor(private action: CarouselActionType, private label: string) {}

  getPayload(): any {
    return {
      category: ApplicationEventType.Interaction,
      action: this.action,
      label: this.label
    };
  }
}
